module.exports = __webpack_public_path__ + "img/baby vaccination.c1adba7a.jpg";